<template>
  <section class="settings-section section-block">
    <SectionTitle
      cyBtn="edit-time-parameter"
      :title="displayData.title"
      :btn="displayData.btn.edit"
      @edit="modal.edit = true"
    />
    <div>
      <BaseElForm label-position="left" label-width="250px">
        <BaseElFormItem class="settings-item">
          <template slot="label">
            <div class="flex items-center" style="gap: 8px">
              <p>{{ displayData.timeUnit.label }}</p>
              <TipInfo :size="16" width="200">
                <p>{{ displayData.timeUnit.tooltip }}</p>
              </TipInfo>：
            </div>
          </template>
          <span class="content">{{ displayData.timeUnit.value }}</span>
        </BaseElFormItem>

        <BaseElFormItem class="settings-item">
          <template slot="label">
            <div class="flex items-center" style="gap: 8px">
              <p>{{ displayData.timeUnitOffset.label }}</p>
              <TipInfo :size="16" width="200">
                <p>{{ displayData.timeUnitOffset.tooltip }}</p>
              </TipInfo>：
            </div>
          </template>
          <span class="content">{{ displayData.timeUnitOffset.value }}</span>
        </BaseElFormItem>
      </BaseElForm>
    </div>

    <EditReservationBasicSettingsModal
      v-if="modal.edit"
      data-testid="edit-reservation-basic-settings-modal"
      :configData="configData"
      @close="modal.edit = false"
      @refresh="$emit('refresh')"
    />
  </section>
</template>

<script>
import { defineComponent, reactive, computed } from 'vue'
import EditReservationBasicSettingsModal from './EditReservationBasicSettingsModal/EditReservationBasicSettingsModal.vue'
import TipInfo from '@/components/TipInfo.vue'
import { i18n } from '@/plugins/i18n/i18n'
import { get } from 'lodash'

export default defineComponent({
  name: 'ReservationBasicSettings',
  components: {
    EditReservationBasicSettingsModal,
    TipInfo,
  },
  props: {
    configData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const modal = reactive({
      edit: false,
    })
    const displayData = computed(() => {
      const data = {
        title: i18n.t('reservationBasicSettings.title'),
        btn: {
          edit: i18n.t('common.button.edit.text'),
        },
        timeUnit: {
          label: i18n.t('reservationBasicSettings.timeUnit.title'),
          tooltip: i18n.t('reservationBasicSettings.timeUnit.tooltip'),
          value: get(props.configData, 'timeUnit', i18n.t('common.notSetupYet.text')),
        },
        timeUnitOffset: {
          label: i18n.t('reservationBasicSettings.timeUnitOffset.title'),
          tooltip: i18n.t('reservationBasicSettings.timeUnitOffset.tooltip'),
          value: get(props.configData, 'timeUnitOffset', i18n.t('common.notSetupYet.text')),
        },
      }
      return data
    })
    return {
      modal,
      displayData,
    }
  },
})
</script>

<style lang="postcss" scoped></style>
